export const fetchAndParseRoomPrice = async (hotel, roomType, prixtype) => {
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;

    try {
        const response = await fetch(`${apiUrl}/api/hotel/${hotel}/room/${roomType}/prixRoom/${prixtype}`, {
            headers: { 'Authorization': `Bearer ${token}`},
        });

        
        const prices = await response.json();
        const logsimple = prices.pricing.logsimple || 0;
        const petidej = prices.pricing.petidej || 0;
        const dejenner = prices.pricing.dejenner || 0;
        const dinner = prices.pricing.dinner || 0;


        return { logsimple, petidej, dejenner, dinner };
    } catch (error) {
        console.error('Error fetching room prices:', error);
        return { logsimple: 0, petidej: 0, dejenner: 0, dinner: 0 };
    }
};
export const calculateRoomPrice = async (pension,hotel,roomType,prixtype) => {
    if(!pension || !hotel || !roomType){
        return 0;
    }
    let roomPrice = 0;
    const { logsimple, petidej, dejenner, dinner } = await fetchAndParseRoomPrice(hotel,roomType,prixtype);
    console.log("logsimple",logsimple);
    console.log("petidej",petidej);
    console.log("dejenner",dejenner);
    console.log("dinner",dinner);
    switch (pension) {
        case 'اقامة فقط':
            roomPrice += logsimple; 
            break;
        case 'اقامة مع فطور صباح':
            roomPrice += petidej+logsimple; 
            break;
        case 'نصف اقامة':
            roomPrice = logsimple+petidej+dejenner;
            break;
        case 'اقامة كاملة':
            roomPrice = logsimple+petidej+dejenner+dinner;
            break;
        default:
            roomPrice = 0;
    }
    return roomPrice; 
};